import AwesomeDebouncePromise from 'awesome-debounce-promise';
import ApiService from '../services/apiService';

export const indexHelpCategoriesRequest = ({ dispatch, params = {}, failureCallback, successCallback }) =>
  ApiService.request('get', '/help_categories', {
    dispatch,
    params,
    failureCallback,
    successCallback
  });

export const debounceIndexHelpCategoriesRequest = AwesomeDebouncePromise(
  ({ dispatch, params = {}, failureCallback, successCallback }) =>
    ApiService.request('get', '/help_categories', {
      dispatch,
      params,
      failureCallback,
      successCallback
    }),
  300
);
